// extracted by mini-css-extract-plugin
export default {"productLink":"HorizontalLinks_productLink__Udsa5"};